import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=becf1b5c&scoped=true&"
import script from "./Poster.vue?vue&type=script&lang=ts&"
export * from "./Poster.vue?vue&type=script&lang=ts&"
import style0 from "./Poster.vue?vue&type=style&index=0&id=becf1b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf1b5c",
  null
  
)

export default component.exports